//记得在 src\components\lang\zhLoad.js 里面添加对象
const docMgr = {
  docType: '文档类型',
  msg: {
  }
};
export default docMgr



// WEBPACK FOOTER //
// ./src/page/sm/docMgr/lang/docMgr.en.js